export default "__VITE_ASSET__B_h3j4ua__"